export const filterNullable = (obj) => Object.keys(obj).reduce((accum, key) => {
  const value = obj[key];

  if (value != null) {
    accum[key] = value;
  }

  return accum;
}, { });
